export default __webpack_public_path__ + "static/media/pos-product-display-homepage-img.7bdec8b0.png";